class ZPLoopSlider {
  constructor(sliderComponent) {
    this.root = sliderComponent;
    this.ul = this.root.querySelector('ul');
    if (!this.ul) return;

    this.slides = Array.from(this.ul.querySelectorAll('li'));
    if (this.slides.length < 2) return;

    this.visibleDesktop = parseInt(this.root.dataset.zpVisibleDesktop || "4", 10);
    this.visibleMobile = parseInt(this.root.dataset.zpVisibleMobile || "2", 10);
    this.peek = parseInt(this.root.dataset.zpPeek || "24", 10); // px
    this.enabled = this.root.dataset.zpLoop === "true";

    if (!this.enabled) return;

    this.isDesktop = window.matchMedia("(min-width: 750px)").matches;
    this.visible = this.isDesktop ? this.visibleDesktop : this.visibleMobile;
    this.cloneCount = Math.min(this.visible, this.slides.length);

    this.setup();
    window.addEventListener("resize", () => this.onResize());
  }

  setup() {
    // evita doppio init
    if (this.root.dataset.zpInited === "true") return;
    this.root.dataset.zpInited = "true";

    // clona ultimi N all'inizio
    const headClones = this.slides.slice(-this.cloneCount).map(li => li.cloneNode(true));
    headClones.forEach(li => {
      li.classList.add("zp-clone");
      this.ul.insertBefore(li, this.ul.firstChild);
    });

    // clona primi N alla fine
    const tailClones = this.slides.slice(0, this.cloneCount).map(li => li.cloneNode(true));
    tailClones.forEach(li => {
      li.classList.add("zp-clone");
      this.ul.appendChild(li);
    });

    // aggiorna lista completa
    this.allSlides = Array.from(this.ul.querySelectorAll('li'));

    // misura step (larghezza slide + gap)
    this.recalcStep();

    // posizione iniziale: vai ai "veri" ma lasciando peek a sinistra
    requestAnimationFrame(() => {
      this.ul.scrollLeft = (this.cloneCount * this.step) - this.peek;
    });

    // ascolta scroll per "teletrasporto invisibile"
    this.ul.addEventListener("scroll", () => this.onScroll(), { passive: true });
  }

  recalcStep() {
    const first = this.ul.querySelector("li");
    if (!first) return;
    const rect = first.getBoundingClientRect();
    const gap = this.getGap();
    this.step = rect.width + gap;
  }

  getGap() {
    const styles = window.getComputedStyle(this.ul);
    // gap può essere "column-gap" o "gap"
    const g = parseFloat(styles.columnGap || styles.gap || "0");
    return isNaN(g) ? 0 : g;
  }

  onScroll() {
    if (!this.step) return;

    const totalReal = this.slides.length;
    const startReal = this.cloneCount * this.step;
    const endReal = (this.cloneCount + totalReal) * this.step;

    // se vai troppo a sinistra (sei finito nei cloni di testa)
    if (this.ul.scrollLeft < (startReal - this.step * 0.5)) {
      // spostati alla fine dei veri mantenendo peek
      this.ul.scrollLeft = (endReal - this.step) - this.peek;
      return;
    }

    // se vai troppo a destra (sei finito nei cloni di coda)
    if (this.ul.scrollLeft > (endReal + this.step * 0.5)) {
      // torna all'inizio dei veri mantenendo peek
      this.ul.scrollLeft = startReal - this.peek;
      return;
    }
  }

  onResize() {
    const nowDesktop = window.matchMedia("(min-width: 750px)").matches;
    // se cambi breakpoint, qui servirebbe reinit: per semplicità refresh pagina
    // (è rarissimo che uno ridimensioni da mobile a desktop sul sito vero)
    if (nowDesktop !== this.isDesktop) return;

    this.recalcStep();
  }
}

// init su tutti gli slider che lo chiedono
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("slider-component[data-zp-loop='true']").forEach(el => {
    new ZPLoopSlider(el);
  });
});
